module.exports = "https://static.wmbcdn.com/uniweb/images/ee7c6e6deca2d805f740a2e8900afb94.svg";